import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useProvideCarousel } from './useCarousel'
import type { CarouselEmits, CarouselProps, WithClassAsProps } from './interface'
import { cn } from '@/utils/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'Carousel',
  props: {
    opts: {},
    plugins: {},
    orientation: { default: 'horizontal' },
    class: {}
  },
  emits: ["init-api"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emits = __emit

const carouselArgs = useProvideCarousel(props, emits)

__expose(carouselArgs)

function onKeyDown(event: KeyboardEvent) {
  const prevKey = props.orientation === 'vertical' ? 'ArrowUp' : 'ArrowLeft'
  const nextKey = props.orientation === 'vertical' ? 'ArrowDown' : 'ArrowRight'

  if (event.key === prevKey) {
    event.preventDefault()
    carouselArgs.scrollPrev()

    return
  }

  if (event.key === nextKey) {
    event.preventDefault()
    carouselArgs.scrollNext()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('relative', props.class)),
    role: "region",
    "aria-roledescription": "carousel",
    tabindex: "0",
    onKeydown: onKeyDown
  }, [
    _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps(_unref(carouselArgs))))
  ], 34))
}
}

})